<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3073_1689)">
<rect x="1.85" y="1.85" width="18.3" height="18.3" rx="2.15" stroke="currentColor" stroke-width="1.7"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.3996 5.01489V9.88527H5.10016C5.58119 7.2891 7.73373 5.27957 10.3996 5.01489ZM11.5996 5.01489L11.5996 11.0853L5.00037 11.0853C5.05376 14.3529 7.71924 16.9853 10.9995 16.9853C14.3133 16.9853 16.9995 14.299 16.9995 10.9853C16.9995 7.87406 14.6315 5.31593 11.5996 5.01489Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3073_1689">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
